import React, { Component } from 'react';
import { parse } from 'query-string';
import './App.css';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import WizardHeader from './WizardHeader';
import WizardFooter from './WizardFooter';
import { Trans } from 'react-i18next';


import transomColor1 from './assets/transomColors/transom-color_1.jpg';
import transomColor2 from './assets/transomColors/transom-color_2.jpg';
import transomColor3 from './assets/transomColors/transom-color_3.jpg';
import transomColor4 from './assets/transomColors/transom-color_4.jpg';
import transomColor6 from './assets/transomColors/transom-color_6.jpg';
import transomColor7 from './assets/transomColors/transom-color_7.jpg';
import transomColor8 from './assets/transomColors/transom-color_8.jpg';
import transomColor9 from './assets/transomColors/transom-color_9.jpg';
import transomColor10 from './assets/transomColors/transom-color_10.jpg';
import transomColor11 from './assets/transomColors/transom-color_11.jpg';


class ConfiguratorContainer extends Component {
    constructor(props) {
        super(props);

        this.logoLink = 'https://www.x-yachts.com/en/';

        this.fontOptions = [
            { value: 'neuropol x free', label: this.props.t('neuropol x free') },
            { value: 'CRILLEE', label: this.props.t('Crillée') },
            { value: 'Chalet-ParisSixty', label: this.props.t('Chalet Paris') },
            { value: 'Chalet-LondonSixty', label: this.props.t('Chalet London') },
            { value: 'times new roman', label: this.props.t('Times New Roman') }
        ];

        this.sizeOptions = [
            { value: 50, label: '50' },
            { value: 75, label: '75' },
            { value: 100, label: '100' },
            { value: 125, label: '125' },
            { value: 150, label: '150' },
            { value: 175, label: '175' },
            { value: 200, label: '200' },
            { value: 250, label: '250' },
            { value: 300, label: '300' },
            { value: 350, label: '350' },
            { value: 400, label: '400' }
        ];

        this.colorOptions = [
            { value: '#81A3C6', label: this.props.t('Pastel Blue'), thumbnail: transomColor10 },
            { value: '#fefefe', label: this.props.t('Pure White'), thumbnail: transomColor1 },
            { value: '#c5c7c4', label: this.props.t('Light Grey'), thumbnail: transomColor2 },
            { value: '#2f3234', label: this.props.t('Black Grey'), thumbnail: transomColor3 },
            { value: '#1a2b3c', label: this.props.t('Dark Blue'), thumbnail: transomColor4 },
            { value: '#ffffff', label: this.props.t('White'), thumbnail: transomColor6 },
            { value: '#555555', label: this.props.t('Grey'), thumbnail: transomColor7 },
            { value: '#c6c6c4', label: this.props.t('Silver'), thumbnail: transomColor8 },
            { value: '#d3222a', label: this.props.t('Red'), thumbnail: transomColor9 },
            { value: '#b8b0a2', label: this.props.t('Pebble Grey'), thumbnail: transomColor11 }
        ];


        const query = parse(this.props.location.search, { ignoreQueryPrefix: true });
        let country = '';
        if (query.country !== undefined) {
            country = query.country;
            localStorage.setItem("country", query.country);
        } else if (localStorage.getItem("country") !== undefined) {
            country = localStorage.getItem("country");
        }

        this.state = {
            country: country,
            countries: [],
            boat: '',
            exterior: {},
            transom: {
                Name: {
                    value: this.props.t('My yacht'),
                    font: this.fontOptions[0],
                    size: this.sizeOptions[2],
                    color: this.colorOptions[0],
                    horizontalOffset: 0,
                    verticalOffset: 0
                },
                Port: {
                    value: this.props.t('Harbor (optional)'),
                    font: this.fontOptions[0],
                    size: this.sizeOptions[1],
                    color: this.colorOptions[0],
                    horizontalOffset: 0,
                    verticalOffset: 350
                }
            },
            interior: {}
        };

        this.steps = [];


        this.handleExteriorConfigurationChange = this.handleExteriorConfigurationChange.bind(this);
        this.handleInteriorConfigurationChange = this.handleInteriorConfigurationChange.bind(this);
        this.handleTransomChange = this.handleTransomChange.bind(this);
        this.generateCode = this.generateCode.bind(this);
        this.parseCode = this.parseCode.bind(this);
    }

    componentDidMount() {
        const query = parse(this.props.location.search, { ignoreQueryPrefix: true });
        if (query.code !== undefined) {
            this.parseCode(query.code);
        }

        fetch("/api/dealerships")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        countries: result.map(c => { return { value: c.iso, label: c.country }; })
                    });
                }
            );
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            const scrollPanel =
                document.querySelector('.App-container .section .optionsScroll') ||
                document.querySelector('.App-container .section .option');
            if (scrollPanel) {
                scrollPanel.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }

    generateCode() {
        return "";
    }

    parseCode(code) {

    }

    handleExteriorConfigurationChange(newConfiguration) {
        this.setState({ exterior: newConfiguration });
    }

    handleInteriorConfigurationChange(newConfiguration) {
        this.setState({ interior: newConfiguration });
    }

    handleTransomChange(newConfiguration) {
        this.setState({ transom: newConfiguration });
    }

    renderSteps() {

    }

    render() {
        return (
            <div className="App-layout">
                <header className="App-header">
                    <div className="App-header-inner">
                        <h1 className="App-title">
                            <a href={this.logoLink}>
                                <img alt={this.state.boat} src={this.logo} />
                                <span><Trans defaults='Configurator' /></span>
                            </a>
                        </h1>
                    </div>
                </header>

                <div className="App">
                    <WizardHeader steps={this.steps} currentStep={this.props.location.pathname} />

                    <div className="App-container">
                        <TransitionGroup>
                            <CSSTransition key={this.props.location.key} classNames="fade" timeout={300}>
                                    {this.renderSteps()}
                            </CSSTransition>
                        </TransitionGroup>
                    </div>
                </div>

                <WizardFooter steps={this.steps} currentStep={this.props.location.pathname} />
            </div>
        );
    }
}

export default ConfiguratorContainer;


// WEBPACK FOOTER //
// ./src/ConfiguratorContainer.js